import { render, staticRenderFns } from "./SchedulingDashboardMyFormsInstructor.vue?vue&type=template&id=c7319b46&scoped=true&"
import script from "./SchedulingDashboardMyFormsInstructor.vue?vue&type=script&lang=js&"
export * from "./SchedulingDashboardMyFormsInstructor.vue?vue&type=script&lang=js&"
import style0 from "./SchedulingDashboardMyFormsInstructor.vue?vue&type=style&index=0&id=c7319b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7319b46",
  null
  
)

export default component.exports